// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.css']
// })
// export class AppComponent {
//   title = 'app';
// }

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Basic Routing Template';
  currentUsername: string = "Unknown";
  
  navRoutes = [
		{ route: '/home', icon: 'home', name: 'Home' },
		{ route: '/neat', icon: 'neat', name: 'Secure' },
  ]
  
  constructor(private router: Router, private _authService: AuthService) {
    _authService.userLoadedEvent.subscribe((user:any) => {
			this.currentUsername = user.profile.name;
		});
  }

  navigate(route: any) {
    console.log('navigate ' + route);
		this.router.navigate([route]);
  }

  logout() {
    if (this._authService.IsAuthorized)
		  this._authService.Logoff();
	}
}
